import {TimeDelta} from "../time.js";
import Statistic from "./Statistic.js"

export class DailyStatistics {

    constructor(operation = Statistic.AVERAGE, dataType = Statistic.NUMBER) {
        this.dailyStats = {};
        this.firstDay = null;
        this.lastDay = null;
        this.operation = operation;
        this.dataType = dataType;
    }

    add({value, date, isSample=true}) {
        const day = TimeDelta.floorToDay(date);
        if (day && (this.firstDay === null || day.getTime() < this.firstDay.getTime())) {
            this.firstDay = day;
        }
        if (day && (this.lastDay === null || day.getTime() > this.lastDay.getTime())) {
            this.lastDay = day;
        }
        if (this.dailyStats[day] === undefined) {
            this.dailyStats[day] = new Statistic(this.operation, this.dataType);
        }
        this.dailyStats[day].add({value, isSample});
    }

    toString() {
        const str = `DailyOnlineStatistics: ${this.operation} from ${this.firstDay} to ${this.lastDay}:`;
        const stats = Object.entries(this.dailyStats).map(
            ([date, stat]) => {
                return `${date}: ${stat.toString()}`
            }
        )
    }
}


export default DailyStatistics;